import { ReactNode } from 'react';
import { useRouter } from 'next/router';
import { useCurrentAccountId } from '@zapier/common-hooks';
import { UniversalLayout } from '@zapier/universal-layout';
import { useQuery, useMutation } from '@apollo/react-hooks';
import styled from '@emotion/styled';
import { useTrackEvent } from 'tracking/useTrackEvent';

type Props = { children: ReactNode };

export const UniversalNavigation = ({ children }: Props) => {
  const trackEvent = useTrackEvent();
  const currentUrl = useRouter()?.pathname || '';
  const currentAccountId = useCurrentAccountId();
  return (
    <Outer>
      <UniversalLayout
        currentAccountId={currentAccountId}
        currentUrl={currentUrl}
        useQuery={useQuery}
        renderAlertBanner={() => null}
        // @ts-ignore: as suggested by Alej (https://github.com/zapier/blog/pull/375#discussion_r545454080)
        trackEvent={trackEvent}
        useMutation={useMutation}
      >
        {children}
      </UniversalLayout>
    </Outer>
  );
};

const Outer = styled.div`
  /**
  ATC-739: @alejandro We're hiding the "Menu" pill using global CSS.
  It's not possible to use Styled components in UniversalNavigation as it doesn't
  accept a className props, making the styled(Component) api useless.

  I'd consider this a hack as we don't know if that ID is going to change at all in the future,
  and if it does, the Menu pill will show again. For now, Fast Follow Blog V1, this is fine though.

  Targeting the data-testid=tooltip-null didn't work, so I went with the #id selector.
   */

  span#tooltip-1 {
    display: none;
  }
`;
